"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TimePicker;
exports.parseISOTime = parseISOTime;

var React = _interopRequireWildcard(require("react"));

var _button = require("../button");

var _TimePickerModule = _interopRequireDefault(require("./TimePicker.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function TimePicker({
  possibleTimes,
  onSelect
}) {
  const CHUNK_SIZE = 5;
  const [loadedIndex, setLoadedIndex] = React.useState(CHUNK_SIZE);
  const times = possibleTimes.slice(0, loadedIndex);
  const [submitting, setSubmitting] = React.useState(false);
  const [selectedTime, setSelectedTime] = React.useState();
  const datetime = new Date();
  return /*#__PURE__*/React.createElement(React.Fragment, null, times.map(time => {
    const date = parseISOTime(time.start_time, datetime);
    return /*#__PURE__*/React.createElement(ConfirmButton, {
      key: time.start_time,
      selected: selectedTime === time.start_time,
      onFirstClick: () => setSelectedTime(time.start_time),
      disabled: submitting,
      onConfirmClick: async () => {
        setSubmitting(true);

        try {
          await onSelect(time.start_time);
        } catch (err) {
          console.error(err);
          setSubmitting(false);
        }
      }
    }, submitting && selectedTime === time.start_time ? 'Saving...' : formatTime(datetime));
  }), loadedIndex <= possibleTimes.length && /*#__PURE__*/React.createElement(_button.UnstyledButton, {
    className: _TimePickerModule.default.loadMoreButton,
    onClick: () => setLoadedIndex(prev => prev + CHUNK_SIZE)
  }, "Load more times"));
}

function ConfirmButton({
  children,
  onConfirmClick,
  selected,
  onFirstClick,
  disabled
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: _TimePickerModule.default.buttonRow
  }, /*#__PURE__*/React.createElement(_button.Button, {
    size: "medium",
    style: {
      flex: '1'
    },
    disabled: disabled,
    onClick: onFirstClick
  }, children), selected && /*#__PURE__*/React.createElement(_button.Button, {
    size: "medium",
    type: "primary",
    disabled: disabled,
    onClick: onConfirmClick
  }, "Confirm"));
}

function formatTime(date) {
  return date.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: 'numeric'
  });
}

function parseISOTime(string, datetime = new Date()) {
  const [hour, minute] = string.split(':');
  datetime.setHours(Number(hour));
  datetime.setMinutes(Number(minute));
  return datetime;
}